var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item-icon account-menu-container",
      class: _vm.style(),
      on: { click: _vm.accountMenuAction }
    },
    [
      _vm.loggedIn
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "line-clamp",
                  rawName: "v-line-clamp:20",
                  value: 1,
                  expression: "1",
                  arg: "20"
                }
              ],
              staticClass: "truncate-name user-name"
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.userName) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isGuestLogin
        ? _c("div", { staticClass: "guest" }, [_vm._v("\n\t\tguest\n\t")])
        : _vm._e(),
      _vm._v(" "),
      _vm.showAccountIcon
        ? [
            _vm.isNoLogin
              ? _c("BaseIcon", {
                  attrs: { icon: "account", isCustom: true, type: "standard" }
                })
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.showAccountIcon
        ? [
            _vm.isNoLogin
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "line-clamp",
                        rawName: "v-line-clamp:20",
                        value: 1,
                        expression: "1",
                        arg: "20"
                      }
                    ],
                    staticClass: "truncate-name user-name"
                  },
                  [_vm._v("Sign In")]
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a3d8912", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a3d8912","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationItems/AccountMenu.vue
// module id = null
// module chunks = 